import apiClient from './apiClient';

export const sendForgotPasswordOtp = async (email) => {
  try {
    const response = await apiClient.post('/admin/forgot-password/send-otp', {
      email,
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to send OTP';
    throw new Error(message);
  }
};

export const verifyForgotPasswordOtp = async (email, otp) => {
  try {
    const response = await apiClient.post('/admin/forgot-password/verify-otp', {
      email,
      otp,
    });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'OTP verification failed';
    throw new Error(message);
  }
};

export const resetPassword = async (password, resetToken) => {
  try {
    const response = await apiClient.put(
      '/admin/reset-password',
      { password },
      {
        headers: {
          Authorization: `Bearer ${resetToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Password reset failed';
    throw new Error(message);
  }
};
